import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";

import {
    Card,
    CardBody,
    CardHeader
} from "../../../../_metronic/_partials/controls";
import ConfirmDialog from '../../../components/dialogs/ConfirmDialog'
import Table, {
    dateFormatter,
    buttonsStyle,
    substringFormatter
} from "../../../components/tables/table";
import { Button, Tooltip } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { getAllContacts, deleteContact } from "../../../../api/contact";
import { alertError, alertSuccess } from '../../../../utils/logger'

export default function ContactsPage() {
    const history = useHistory();
    const user = useSelector((store) => store.authentication?.user, shallowEqual);
    const [refresh, setRefresh] = useState(false)
    const [data, setData] = useState([])
    const [filteredData, setFilteredData] = useState([])
    const [contactId, setContactId] = useState(null);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(null)

    useEffect(() => {
        getAllContacts()
            .then((res) => {
                setData(res.data);
                setFilteredData(res.data);
                setRefresh(false);
            })
            .catch(error => {
                alertError({ error: error, customMessage: 'Could not get contacts.' })
            })
    }, [refresh]);

    function buttonFormatter(cell) {
        const elem = data.find((item) => item._id === cell);
        return (
            <>
                <Tooltip title="Watch">
                    <Button
                        style={buttonsStyle}
                        size="small"
                        onClick={() => {
                            history.push("/watch-contact/" + elem._id)
                        }}
                    >
                        <VisibilityIcon />
                    </Button>
                </Tooltip>
                {user?.role === "admin" && (
                    <>
                        <Tooltip title="Delete">
                            <Button
                                style={buttonsStyle}
                                size="small"
                                onClick={() => {
                                    setContactId(elem._id);
                                    setOpenConfirmDialog(2);
                                }}
                            >
                                <DeleteIcon />
                            </Button>
                        </Tooltip>
                    </>
                )}
            </>
        );
    }


    const columns = [
        { dataField: "fullName", text: "Name", sort: true },
        { dataField: "email", text: "Email", sort: true },
        { dataField: "info", text: "Information", sort: false, formatter: substringFormatter },
        {
            dataField: "createdAt",
            text: "Created at",
            formatter: dateFormatter,
            sort: true,
        },
        { dataField: "_id", text: "", formatter: buttonFormatter, headerStyle: { width: '150px' } }
    ];

    return (
        <>
            <Card>
                <CardHeader title="Contacts list">
                </CardHeader>
                <CardBody>
                    <Table data={filteredData} columns={columns} key={data.length} />
                    <ConfirmDialog
                        title={'Are you sure you want to remove this contact?'}
                        open={openConfirmDialog === 2}
                        setOpen={setOpenConfirmDialog}
                        onConfirm={() => {
                            deleteContact(contactId)
                                .then((res) => {
                                    alertSuccess({
                                        title: 'Deleted!',
                                        customMessage: 'Contact removed successfully.',
                                    });
                                    setRefresh(true);
                                })
                                .catch((error) => {
                                    alertError({
                                        error: error,
                                        customMessage: 'Could not remove contact.',
                                    });
                                });
                        }}
                    />
                </CardBody>
            </Card>
        </>
    );
}